import Url from "./Api";
import axios from 'axios';
const authAxios = axios.create({
    baseURL: Url,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  export default authAxios;